import { Flex, Text } from "@chakra-ui/react";
import React from "react";

const CardTypeItem = ({ text, value, isLast }) => {
  return (
    <Flex
      justify="space-between"
      py="12px"
      borderBottomColor={!isLast && "border.input"}
      borderBottomWidth={!isLast && "1px"}
    >
      <Text as="span" color="text.grey" textStyle="bodySmall">
        {text}
      </Text>
      <Text as="span" color="text.black" textStyle="bodySmall" fontWeight="500">
        {value}
      </Text>
    </Flex>
  );
};

export default CardTypeItem;
